const ProjectIndex =
{
    "boldapps":
    {
        Id: [""],
        Name: "SmartCard Citizen",
        Folder: "boldapps",
        Config: "assets/projects/boldapps/config.json",
        Domain: "admin.smartcardcitizen.boldapps.pt"
    },
    "fornosalgodres":
    {
        Id: [
            "5cce6626-02e8-4bce-87d0-1b83afe3d1d9", //  PROD
            "0B6CE295-E248-45B8-BE42-16B566DAF16F" // DEV
        ],
        Name: "Municipio de Fornos de Algodres",
        Folder: "fornosalgodres",
        Config: "assets/projects/fornosalgodres/config.json",
        Domain: ["gestaocartao.lojadobairro.com.pt", "gestaocartao.lojadobairro.pt"]
    },
    "funchal":
    {
        Id: [
            "460E4BE6-B439-49DE-928A-C23AB3413C1C", // PROD
            "b12d89c5-b8a0-441b-b60c-cd39094d8e8f" // DEV
        ],
        Name: "Municipio de Funchal",
        Folder: "funchal",
        Config: "assets/projects/funchal/config.json",
        Domain: "gestaocartaodomunicipe.funchal.pt"
    },
    "santarem":
    {
        Id: [
            "308D5CCC-29E0-4056-ACAD-AE722F101860", // PROD
            "E0566CC9-A8C3-49C1-8760-BB722F540086" // DEV
        ],
        Name: "Municipio de Santarém",
        Folder: "santarem",
        Config: "assets/projects/santarem/config.json",
        Domain: "gestaocartao.santarem.pt"
    },
    "vianacastelo":
    {
        Id: [
            "2bc32790-1175-435b-9a58-46c23614d552", // PROD
            "E2F501EE-08C0-4087-9C2D-1EBCABA87BD4" // DEV
        ],
        Name: "Municipio de Viana do Castelo",
        Folder: "vianacastelo",
        Config: "assets/projects/vianacastelo/config.json",
        Domain: "cartaodevianagestao.cm-viana-castelo.pt"
    },
    "soure":
    {
        Id: [
            "", // PROD
            "289FF94A-869E-453C-A9A3-7E54712AEAF9" // DEV
        ],
        Name: "Municipio de Viana do Castelo",
        Folder: "vianacastelo",
        Config: "assets/projects/soure/config.json",
        Domain: "gestao.cartao.sourecomercial.pt"
    },
    "alvaiazere":
    {
        Id: [""],
        Name: "",
        Folder: "alvaiazere",
        Config: "assets/projects/alvaiazere/config.json",
        Domain: "admin.cartaodomunicipe.cm-alvaiazere.pt"
    }
};

export default ProjectIndex;